var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13H2.06667C1.6933 13 1.50661 13 1.36401 12.9273C1.23856 12.8634 1.13658 12.7614 1.07266 12.636C1 12.4934 1 12.3067 1 11.9333V1M12.3333 4.33333L9.72075 7.12177C9.62174 7.22745 9.57224 7.28029 9.51251 7.3076C9.4598 7.3317 9.40171 7.34164 9.34398 7.33644C9.27857 7.33055 9.21431 7.29718 9.08579 7.23045L6.91421 6.10288C6.78569 6.03615 6.72143 6.00278 6.65602 5.99689C6.59829 5.99169 6.54021 6.00163 6.48749 6.02574C6.42777 6.05305 6.37826 6.10589 6.27925 6.21156L3.66667 9",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.e5df16d1c99f901ad0545b430aff723f.svg";
export { ForwardRef as ReactComponent };